module.exports = __webpack_public_path__ + "assets/img/wine-rose.37ba4b54.svg";